const { NODE_ENV } = process.env

module.exports = {
    //库金定时刷新
    warehouseMoneyTime: 5 * 60 * 1000,

    subApp: NODE_ENV == "development" ? 'http://192.168.8.173:9001' : '/subapp/extend/'
}